import { DateTime } from 'luxon';

import Hour from './Hour';

export default class Day {
  public hours: Hour[];

  constructor(public date: DateTime) {
    this.hours = [];
    for (let i = 0; i < 24; i += 1) {
      this.hours.push(new Hour(this, i));
    }
  }

  get index() {
    return this.date.weekday;
  }

  get label() {
    return this.date.toLocaleString({ weekday: 'short' });
  }

  get compactLabel() {
    return this.date.toLocaleString({ weekday: 'narrow' });
  }

  get labelTiny() {
    return this.date.toLocaleString({ weekday: 'narrow' });
  }

  get labelBig() {
    return this.date.toLocaleString({ weekday: 'long' });
  }

  clone() {
    const cloned = new Day(this.date);
    cloned.hours = this.hours.map((x) => x.clone());
    return cloned;
  }
}
